// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Cursor extends Phaser.GameObjects.Image {
  constructor(
    scene: Phaser.Scene,
    x?: number,
    y?: number,
    texture?: string,
    frame?: number | string,
  ) {
    super(scene, x ?? 0, y ?? 0, texture || '1x1sprite', frame);

    this.scaleX = 4;
    this.scaleY = 64;
    this.tintTopLeft = 6896829;
    this.tintTopRight = 6896829;
    this.tintBottomLeft = 6896829;
    this.tintBottomRight = 6896829;

    /* START-USER-CTR-CODE */
    this.initialize();
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  initialize() {
    this.scene.tweens.add({
      targets: this,
      alpha: 0,
      delay: 100,
      duration: 500,
      repeat: -1,
      yoyo: true,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
